import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AllVehicleTypeDetails,
  CreateVehicleTypeDetails,
  UpdateVehicleTypeDetails,
} from "../../Apis/vehicleApi";
import { AllCollectionTypeDetails } from "../../Apis/collectionTypeApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import Loader from "../../Common/Loader/loader";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";

const VehicleType = ({ t }) => {
  const navigate = useNavigate();
  const headers = [
    "collectionType",
    "vehicleTypeCode",
    "vehicleType",
    "status",
    "actions",
  ];
  const [lgShow, setLgShow] = useState(false);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [collectionTypeDetails, setCollectionTypeDetails] = useState([]);
  const [editVehicleTypeData, setEditVehicleTypeData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [collectionDetails, setCollectionDetails] = useState([]);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [excelData, setExcelData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [filterOriginalVehicleTypeData, setFilterOriginalVehicleTypeData] =
    useState([]);

  useEffect(() => {
    // Combine sortedData with excelData
    setExcelData(sortedData);
  }, [sortedData]);

  const [formInput, setFormInput] = useState({
    vehicleTypeName: "",
    collectionTypeId: "",
    vehicleTypeCode: "",
    isActive: true,
  });
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (typeof value !== "boolean") {
      value = String(value);
    }
    // Function to trim leading spaces and replace multiple spaces with a single space
    const sanitizeSpaces = (input) => input?.trim().replace(/\s{2,}/g, " ");

    switch (name) {
      case "isActive":
        // Directly update the boolean value without modification
        setFormInput((prevData) => ({ ...prevData, [name]: value }));
        break;


      case "vehicleTypeName":
        // Allow only alphabets, numbers, and spaces, and sanitize extra spaces
        const sanitizedValue = sanitizeSpaces(value.replace(/[^A-Za-z0-9 /-]/g, ''));
        setFormInput((prevData) => ({ ...prevData, [name]: value }));

        
        break;


      case "collectionTypeId":
        // If it's a radio button, set the value to 1 or 0 based on the selected radio button
        const intValue = parseInt(value, 10);
        const selectedCollectionType = collectionTypeDetails.find(
          (type) => type.collectionTypeId === intValue
        );
        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue,
          collectionTypeName: selectedCollectionType
            ? selectedCollectionType.collectionTypeName
            : "",
        }));
        break;

      case "vehicleTypeCode":
        // Allow only alphanumeric characters and hyphens, convert to uppercase, and sanitize spaces
        const sanitizedCode = sanitizeSpaces(value.replace(/[^a-zA-Z0-9-]/g, "").toUpperCase());
        setFormInput((prevData) => ({ ...prevData, [name]: sanitizedCode }));
        break;

      default:
        setFormInput((prevData) => ({ ...prevData, [name]: sanitizeSpaces(value) }));
        break;
    }
  };


  const handleClose = () => {
    setFormInput({
      vehicleTypeName: "",
      collectionTypeId: "",
      vehicleTypeCode: "",
      isActive: "",
    });
    setLgShow(false); // Explicitly set lgShow to false
    setFormSubmitted(false);
  };

  const handleShow = () => {
    setLgShow(true);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      id: "",
      vehicleTypeName: "",
      vehicleTypeCode: "",
      isActive: true,
      collectionTypeId: "",
    });
    setEditVehicleTypeData(null);
  };

  // Inside handleEditVehicleTypeData function, set collection type name in formInput state
  const handleEditVehicleTypeData = (selectedVehicleTypeDetails) => {
    setEditVehicleTypeData(selectedVehicleTypeDetails);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      vehicleTypeId: selectedVehicleTypeDetails.vehicleTypeId,
      vehicleTypeCode: selectedVehicleTypeDetails.vehicleTypeCode,
      vehicleTypeName: selectedVehicleTypeDetails.vehicleTypeName,
      collectionTypeId: selectedVehicleTypeDetails.collectionTypeId,
      collectionTypeName: selectedVehicleTypeDetails.collectionTypeName, // Include collection type name
      isActive: selectedVehicleTypeDetails.isActive,
    });
    setLgShow(true);
  };

  const vehcileTypeData = async () => {
    try {
      setIsLoading(true);
      const response = await AllVehicleTypeDetails();
      setVehicleTypeDetails(response);
      setOriginalData(response);
    } catch (error) {
      console.error("Error fetching shift data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const collectionTypeData = async () => {
    try {
      setIsLoading(true);
      const response = await AllCollectionTypeDetails();
      setCollectionTypeDetails(response);
    } catch (error) {
      console.error("Error fetching shift data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(
    () => {
      vehcileTypeData();
      collectionTypeData();
    },
    []
    // [lgShow]
  );

  const handleCreateVehicleTypeDetails = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    try {
      setIsLoading(true);

      // Check if editVehicleTypeData is present (indicating update mode)
      if (editVehicleTypeData) {
        // Perform validation for required fields only when adding new data
        if (
          !formInput.vehicleTypeName ||
          !formInput.collectionTypeId ||
          !formInput.vehicleTypeCode
        ) {
          // toast.error("Please fill in all required fields.", {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          // });
          return;
        }

        // Check for duplicate vehicle type code
      }

      // const isDuplicateCode = vehicleTypeDetails.some(
      //   (type) => type.vehicleTypeCode === formInput.vehicleTypeCode
      // );
      // if (isDuplicateCode) {
      //   toast.error(
      //     "Vehicle Type Code already exists. Please choose a different one.",
      //     {
      //       position: "top-right",
      //       autoClose: 5000,
      //       hideProgressBar: false,
      //     }
      //   );
      //   return;
      // }

      // Handle update or creation based on editVehicleTypeData presence
      if (editVehicleTypeData) {
        // Update existing vehicle type details
        const updatedVehicleTypeData = { ...formInput };
        const response = await UpdateVehicleTypeDetails(updatedVehicleTypeData);
        setVehicleTypeDetails([...vehicleTypeDetails, response]);
        toast.success("Vehicle Type updated successfully!");
        fetchAllVehicleTypeDetails();
        handleClose();
      } else {
        // Add new vehicle type details
        const response = await CreateVehicleTypeDetails(formInput);
        toast.success("Vehicle Type Added successfully!");
        fetchAllVehicleTypeDetails();
        handleClose();
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          // Handle 400 status code errors with validation errors
          const validationErrors = data;
          // for (const field in validationErrors) {
          toast.error(validationErrors, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
          // }
        } else if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else {
          // Handle other status code errors
          toast.error("An error occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        // Handle network errors or other unexpected errors
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    } finally {
      setIsLoading(false); // Set loading back to false after API call completes
    }
  };

  const fetchAllVehicleTypeDetails = async () => {
    const [collectionPointDetails, vehicleTypeResponse] = await Promise.all([
      AllCollectionTypeDetails(),
      AllVehicleTypeDetails(),
    ]);
    const collectionPointTypeData = vehicleTypeResponse.map((station) => {
      const vehicleTypes = vehicleTypeResponse.find(
        (vehicleType) => vehicleType.vehicleTypeId === station.vehicleTypeId
      );
      const collectionTypes = collectionPointDetails.find(
        (collectionType) =>
          collectionType.collectionTypeId === station.collectionTypeId
      );

      return {
        ...station,
        vehicleType: vehicleTypes ? vehicleTypes.vehicleTypeName : "N/A",
        collectionType: collectionTypes
          ? collectionTypes.collectionTypeName
          : "N/A",
        status: station.isActive ? "Active" : "InActive",
        // zone: zone ? zone.zoneName : "N/A",
        // circle: circle ? circle.circleName : "N/A",
      };
    });

    // Sort the data based on the isActive field
    const sortedRouteData = collectionPointTypeData.sort((a, b) => {
      if (a.isActive === b.isActive) {
        return 0;
      }
      return a.isActive ? -1 : 1;
    });

    setCollectionDetails(sortedRouteData);
    setFilterOriginalVehicleTypeData(sortedRouteData);
  };

  useEffect(() => {
    fetchAllVehicleTypeDetails();
  }, []);

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;
  const downloadAsExcel = async (data) => {
    // Create a new workbook and add a worksheet
    const sortedRouteData = data.sort((a, b) => {
      if (a.isActive === b.isActive) {
        return 0;
      }
      return a.isActive ? -1 : 1;
    });
    const dataToUse = sortedRouteData;
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `VehicleType Details`;
    const downloadDateTime = `Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 5); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 5; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "VehicleType Details", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 5); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "VehicleType Details"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 5; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Collection Type",
      "Vehicle Type Code",
      "Vehicle Type",
      "Status",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 5) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Add data rows
    dataToUse.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.collectionTypeName,
          item.vehicleTypeCode,
          item.vehicleTypeName,
          item.isActive ? "Active" : "InActive",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 5) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "VehicleTypeDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  let storedPermissions = localStorage.getItem("permissionId");
  const permissionValues1 =
    JSON.parse(localStorage.getItem("rolePermissions")) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  storedPermissions = parseInt(storedPermissions, 10);

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(
    (mapping) => mapping.permissionId === storedPermissions
  );

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(
      `canWrite value for permission ID ${storedPermissions}:`,
      canWriteValue
    );
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }
  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...collectionDetails].sort((a, b) => {
      if (sortConfig.order === "asc") {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    try {
      const response = await AllVehicleTypeDetails();
      if (response) {
        console.log(response);
        downloadAsExcel(response);
      } else {
        console.error("No valid data received for export");
      }
    } catch (error) {
      console.error("Error fetching or exporting vehicle type details:", error);
    }
  };

  const searchVehicleTypeHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalVehicleTypeData.filter(
      (item) =>
        item?.vehicleTypeName?.toLowerCase()?.includes(term) ||
        item?.vehicleTypeCode?.toLowerCase()?.includes(term)
    );
    setCollectionDetails(data);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      placeholder="Search Vehicle Type or Vehicle Type Code"
                      type="text"
                      className="form-control bg-white"
                      onInput={searchVehicleTypeHandler}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="flex_end_middle mb-3">
                    {/* {canWriteValue === true ? ( */}
                      <button className="button-container" onClick={handleShow}>
                        <i className="fa-solid fa-plus me-1 icon-container "></i>
                        {t("addVehicleType")}
                      </button>
                    {/* ) : (
                      ""
                    )} */}
                    <button
                      className="btn btn-excel"
                      onClick={handleSortAndExport}
                    >
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                      Excel
                    </button>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="top-header">
                    <span>{t("vehicleType")}</span>
                  </div>
                  <TableComponent
                    DataFetchURL={collectionDetails}
                    headers={headers}
                    filterFunction={(data) =>
                      data.filter(
                        (item) => item.status === 1 || item.status === 2
                      )
                    }
                    editData={handleEditVehicleTypeData} // Pass the callback function
                    editDataDetails={editVehicleTypeData}
                    onSort={handleSort}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editVehicleTypeData ? t("editVehicleType") : t("addVehicleType")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleCreateVehicleTypeDetails}>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {t("Collection Type")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    name="collectionTypeId"
                    className={`form-select ${formInput.collectionTypeId || !formSubmitted
                        ? ""
                        : "input-error"
                      }`}
                    onChange={handleInputChange}
                    value={formInput.collectionTypeId} // Set value from formInput state
                    // disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {/* Map through collection types and render options */}
                    {collectionTypeDetails.map((type) => (
                      <option
                        key={type.collectionTypeId}
                        value={type.collectionTypeId} // Make sure this value matches the collectionTypeId
                      >
                        {type.collectionTypeName}
                      </option>
                    ))}
                  </select>
                  {!formInput.collectionTypeId && formSubmitted && (
                    <div className="required-message">
                      Collection Type is Required.
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {t("Vehicle Type Code")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="vehicleTypeCode"
                    className={`form-control ${formInput.vehicleTypeCode || !formSubmitted
                        ? ""
                        : "input-error"
                      }`}
                    placeholder="Enter VehicleType Code"
                    onChange={handleInputChange}
                    value={formInput.vehicleTypeCode}
                    maxLength={8}
                    // disabled={!canWriteValue}
                  />
                  {!formInput.vehicleTypeCode && formSubmitted && (
                    <div className="required-message">
                      Vehicle Type Code is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {t("Vehicle Type")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="vehicleTypeName"
                    className={`form-control ${formInput.vehicleTypeName || !formSubmitted
                        ? ""
                        : "input-error"
                      }`}
                    placeholder="Enter VehicleType"
                    onChange={handleInputChange}
                    value={formInput.vehicleTypeName}
                    maxLength={42}
                    // disabled={!canWriteValue}
                  />
                  {!formInput.vehicleTypeName && formSubmitted && (
                    <div className="required-message">
                      {" "}
                      Vehicle Type is Required.
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4" style={{ marginTop: "5px" }}>
                <label className="form-label">
                  {t("status")}
                  <span style={{ color: "#EC1117" }}> *</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="activeRadio"
                      checked={formInput.isActive} // Check if isActive is true
                      onChange={() =>
                        handleInputChange({
                          target: { name: "isActive", value: true }, // Set value to true
                        })
                      }
                    />

                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "40px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="inactiveRadio"
                      checked={formInput.isActive === false}
                      onChange={() =>
                        handleInputChange({
                          target: { name: "isActive", value: false }, // Set value to false
                        })
                      }
                    />

                    <label className="form-check-label" htmlFor="inactiveRadio">
                      InActive
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {/* {canWriteValue === true ? ( */}
                <button type="submit" className="deployment-button">
                  <i class="fa-solid fa-check done-container"></i>
                  {editVehicleTypeData ? t("Update") : t("Save")}
                </button>
              {/* ) : (
                ""
              )} */}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(VehicleType);
